import type {
  MetaOptions,
  USE_FOR_ANALYTICS_ONLY_HostApp,
} from '../connect/ConnectJSInterface/InitAndUpdateOptionsTypes';
import {defaultHostApp} from '../connect/ConnectJSInterface/InitAndUpdateOptionsTypes';
import type {ReducedMetaOptions} from '../connect/ConnectJsOptions';

export const getUSE_FOR_ANALYTICS_ONLY_HostApp = (
  metaOptions: ReducedMetaOptions | MetaOptions | undefined,
): USE_FOR_ANALYTICS_ONLY_HostApp => {
  // Case for ReducedMetaOptions
  if (metaOptions && 'USE_FOR_ANALYTICS_ONLY_hostApp' in metaOptions) {
    return metaOptions.USE_FOR_ANALYTICS_ONLY_hostApp ?? defaultHostApp;
  }

  // Case for MetaOptions
  if (metaOptions && 'hostApp' in metaOptions) {
    return metaOptions.hostApp ?? defaultHostApp;
  }

  // Default case
  return defaultHostApp;
};

export const hostedOnboardingHostApps: USE_FOR_ANALYTICS_ONLY_HostApp[] = [
  'hostedOnboarding', // remove this once this has rolled out
  'hostedOnboarding_custom',
  'hostedOnboarding_standard',
  'hostedOnboarding_standardOAuth',
  'hostedOnboarding_express',
  'hostedOnboarding_durable',
  'hostedOnboarding_recipientPayouts',
];

const durableFlowHostApps: USE_FOR_ANALYTICS_ONLY_HostApp[] = [
  'durableFlow_embeddedTaxDocuments',
  'durableFlow_capital',
];

export const isHostedOnboardingHostApp = (hostApp: string | undefined) =>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  hostApp &&
  hostedOnboardingHostApps.includes(hostApp as USE_FOR_ANALYTICS_ONLY_HostApp);

export const isDurableFlowHostApp = (hostApp: string | undefined) =>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  hostApp &&
  durableFlowHostApps.includes(hostApp as USE_FOR_ANALYTICS_ONLY_HostApp);
